import css from './index.module.scss';
import { useLang } from '@/i18n';

export default function Benefits() {
    const { t } = useLang('communitylang.benefits');
    const cardsData = [
        {
            key: 1,
            title: t('card_1_title'),
            desc: t('card_1_desc'),
            icon: '',
        },
        {
            key: 2,
            title: t('card_2_title'),
            desc: t('card_2_desc'),
            icon: '',
        },
        {
            key: 3,
            title: t('card_3_title'),
            desc: t('card_3_desc'),
            icon: '',
        },
        {
            key: 4,
            title: t('card_4_title'),
            desc: t('card_4_desc'),
            icon: '',
        },
        {
            key: 5,
            title: t('card_5_title'),
            desc: t('card_5_desc'),
            icon: '',
        },
        {
            key: 6,
            title: t('card_6_title'),
            desc: t('card_6_desc'),
            icon: '',
        },
    ];
    return (
        <div className={`benefits ${css.benefits}`}>
            <div className="benefits-content">
                <p className="benefits-title">{t('title')}</p>
                <p className="benefits-desc">{t('desc')}</p>
            </div>
            <div className="benefits-cards">
                {cardsData.map((card, index) => (
                    <div key={card.key} className="card-item">
                        <div className={`card-svg-${index + 1}`} />
                        <p className="item-title">{card?.title}</p>
                        <p className="item-desc">{card?.desc}</p>
                    </div>
                ))}
            </div>
            <p className="bottom-tip">{t('bottom_tip')}</p>
        </div>
    );
}
